import React from 'react';
import { Route,  NavLink , BrowserRouter as Router, Switch} from 'react-router-dom';
import { NavHashLink as Link } from 'react-router-hash-link';

import { GitHub } from '@material-ui/icons';
import { Facebook } from '@material-ui/icons';
import { Twitter } from '@material-ui/icons';
import { LinkedIn } from '@material-ui/icons';
import Homeing from '../image/undraw_agree_8pb9.svg'

const Home = () => {
    return (
        <div id='home'>
            <div className='fau'></div>
            <img src={Homeing} alt=''></img>
            <div className='home-container'>
                <h1>
                    Hello!!!
                    <br></br>
                    I'm Hasibul Hasan
                </h1>

                <p>Web Developer | Android Developer | UX/UI Designer</p>

                <div className='home-social'>
                    <Router>
                        <ul>
                            <li><a href = 'https://github.com/Siam456'><GitHub fontSize='large' className='github' target="_blank" /></a></li>
                            <li><a href = 'https://www.facebook.com/profile.php?id=100005289167762'><Facebook fontSize='large' className='facebook' target="_blank" /></a></li>
                            <li><a href = 'https://twitter.com/Hasibul58142472'><Twitter fontSize='large' className='twitter' target="_blank" /></a></li>
                          
                        </ul>
                    </Router>
                    
                </div>
            </div>
            
        </div>
    );
};

export default Home;